var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShare2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C46AE899-1EC3-42D2-973C-278CFCAB2CEB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290222 0 0 0 0 0.290175 0 0 0 0 0.290237 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "share2",
    transform: "translate(-688.000000, -211.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(688.000000, 211.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8274785,0.049960968 L12.8399688,0.049960968 C5.77668696,0.049960968 0.049960968,5.77668696 0.049960968,12.8399688 L0.049960968,51.2099922 C0.049960968,58.273274 5.77668696,64 12.8399688,64 L51.2099922,64 C58.273274,64 64,58.273274 64,51.2099922 C64,43.9484653 64,35.2224824 64,35.2224824 C64,33.4574614 62.5675191,32.0249805 60.802498,32.0249805 C59.037477,32.0249805 57.6049961,33.4574614 57.6049961,35.2224824 L57.6049961,51.2099922 C57.6049961,54.7400343 54.7400343,57.6049961 51.2099922,57.6049961 C40.5623107,57.6049961 23.4844528,57.6049961 12.8399688,57.6049961 C9.30672912,57.6049961 6.44496487,54.7400343 6.44496487,51.2099922 C6.44496487,40.5623107 6.44496487,23.4844528 6.44496487,12.8399688 C6.44496487,9.30672912 9.30672912,6.44496487 12.8399688,6.44496487 L28.8274785,6.44496487 C30.5924996,6.44496487 32.0249805,5.012484 32.0249805,3.24746292 C32.0249805,1.48244184 30.5924996,0.049960968 28.8274785,0.049960968 Z M53.0837283,6.44496487 L41.6174863,6.44496487 C39.8524653,6.44496487 38.4199844,5.012484 38.4199844,3.24746292 C38.4199844,1.48244184 39.8524653,0.049960968 41.6174863,0.049960968 L60.802498,0.049960968 C62.5675191,0.049960968 64,1.48244184 64,3.24746292 L64,22.4324746 C64,24.1974957 62.5675191,25.6299766 60.802498,25.6299766 C59.037477,25.6299766 57.6049961,24.1974957 57.6049961,22.4324746 L57.6049961,10.9662326 L34.2856144,34.2856144 C33.0385886,35.5326401 31.0113724,35.5326401 29.7643466,34.2856144 C28.5141233,33.0385886 28.5141233,31.0113724 29.7643466,29.7643466 L53.0837283,6.44496487 Z",
    id: "Shape",
    fill: "#000000"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShare2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share2.a59bbe5a2f65f72af567b0aee9e42532.svg";